import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { DivStyledStatus, returnColor } from "Pages/MyLibrary/MyLibraryTable";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Collapse, Row } from "reactstrap";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import ChapterListViewComponent from "Pages/MyLibrary/FacultyContent/ChapterListViewComponent";
import { useNavigate, useLocation } from "react-router-dom";
import useMasterContext from "Context/MasterContext";
import { Medium } from "utilFunctions/Constants/Constants";
import {
  BASE_URL,
  GET_LISTALLCHAPTERNODES,
} from "utilFunctions/Constants/urlConstants";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import UpBlueArrowIcon from "Assets/Icons/UpBlueArrowIcon";
import DownBlueArrowIcon from "Assets/Icons/DownBlueArrowIcon";
import styled from "styled-components";
import ChapterContentView from "Pages/MyLibrary/FacultyContent/ChapterContent/ChapterContentView";
import ChapterListViewComponentMB from "Pages/MyLibrary/FacultyContent/ChapterListViewComponentMB";
const StyledCard = styled<any>(Card)`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "8px"};
  margin-bottom: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "8px"};
  border-radius: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "0px !important"};
  transition: transform 0.3s ease-in-out;
`;
const StyledCardChapterView = styled<any>(Card)`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "8px"};
  height: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "100%" : "100%"};
  border-radius: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "0px !important"};
  transition: transform 0.3s ease-in-out;
`;
const StyledCardChapterListing = styled<any>(Card)`
  padding: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "0px"};
  height: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "100%" : "100%"};
  border-radius: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "0px !important"};
  transition: transform 0.3s ease-in-out;
`;
const FacultyContentMain = () => {
  const fetchUrl = BASE_URL + GET_LISTALLCHAPTERNODES;
  const navigate = useNavigate();
  const location = useLocation();
  const { masters } = useMasterContext();
  const userInfo = useContext<any>(UserInfoContext);
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const [chapterList, setChapterList] = useState<any[]>([]);
  const [selectedChapter, setSelectedChapter] = useState<any>(null);
  const [courseDetail, setCourseDetail] = useState<any>(null);
  const { screen }: any = useWindowSize();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const pathPart = location.pathname.split("/");
  const courseId = pathPart[pathPart.length - 1];
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { makeRequest: GetChapterList, loading: isChapterListLoader } =
    useGetApi(
      (data) => {
        console.log("isNewCommentAdded", data["data"]["chaptersList"]);
        setCourseDetail(data["data"]);
        if (data["data"] && data["data"]["chaptersList"].length > 0) {
          setChapterList(data["data"]["chaptersList"]);
          setSelectedChapter(data["data"]["chaptersList"][0]);
        } else {
          setChapterList([]);
        }
      },
      (error) => {
        if (
          error &&
          error["response"] &&
          error["response"]["data"] &&
          error["response"]["data"]["internalCode"] &&
          error["response"]["data"]["internalCode"] != "1008"
        ) {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: error.message,
          });
        }
      }
    );
  useEffect(() => {
    const pathParts = location.pathname.split("/");
    const id = pathParts[pathParts.length - 1];
    if (id) {
      GetChapterList(fetchUrl + `?fetchFromDb=${true}&smId=${id}`);
    }
  }, [location]);
  const returnName = (array: any, id: number) => {
    return array?.find((ele: any) => ele.value === id)?.label;
  };
  console.log("selectedSyllabusMaster===", masters, userInfo);
  const courseDetailComp = () => {
    return (
      <div className="d-flex w-100 justify-content-between flex-wrap gap-2 align-items-center">
        {["xxl", "xl", "lg"].includes(screen) && (
          <div>
            <div className="d-flex flex-row align-items-center">
              <LeftArrow
                className={"cursorHoverCSS mr-3 ml-3"}
                onClick={() => {
                  navigate("/admin/mylibrary", {
                    replace: true,
                    state: {
                      selectedStudent: null,
                    },
                  });
                }}
              />
              {
                <Typography
                  variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                  color="black"
                >
                  {["xxl", "xl", "lg"].includes(screen) ? (
                    "My Library"
                  ) : (
                    <div className="d-flex">
                      <span className="detailValueCSS">
                        {courseDetail != null &&
                          returnName(
                            masters?.streams,
                            courseDetail["streamId"]
                          )}{" "}
                        |
                      </span>
                      {courseDetail != null && (
                        <span className="detailValueCSS pl-2">
                          <DivStyledStatus
                            color={returnColor(
                              returnName(
                                masters?.subjects,
                                courseDetail["subjectId"]
                              )
                            )}
                          >
                            {returnName(
                              masters?.subjects,
                              courseDetail["subjectId"]
                            )}
                          </DivStyledStatus>
                        </span>
                      )}
                    </div>
                  )}
                </Typography>
              }
            </div>
          </div>
        )}
        <div>
          Stream:
          <span className="detailValueCSS pl-2">
            {returnName(masters?.streams, courseDetail["streamId"])}
          </span>
        </div>
        <div>
          Class:
          <span className="detailValueCSS pl-2">
            {returnName(masters?.classes, courseDetail["classId"])}
          </span>
        </div>
        <div className="d-flex">
          Subject:
          <span className="detailValueCSS pl-2">
            <DivStyledStatus
              color={returnColor(
                returnName(masters?.subjects, courseDetail["subjectId"])
              )}
            >
              {returnName(masters?.subjects, courseDetail["subjectId"])}
            </DivStyledStatus>
          </span>
        </div>
        <div>
          Board:
          <span className="detailValueCSS pl-2">
            {returnName(masters?.boards, courseDetail["boardId"])}
          </span>
        </div>
        <div>
          Medium:
          <span className="detailValueCSS pl-2">
            {returnName(Medium, courseDetail["language"])}
          </span>
        </div>
      </div>
    );
  };
  const togglePane = () => {
    setIsPaneOpen(!isPaneOpen);
  };
  console.log("CLS=====", selectedChapter);
  return (
    <div
      className={
        ["xs", "sm", "md"].includes(screen)
          ? "facultyContentMB"
          : "batchTableContainer"
      }
    >
      <Row>
        <Col md="12">
          <StyledCard screen={screen}>
            <div className="d-flex flex-column">
              <Row>
                {courseDetail != null && (
                  <>
                    {["xxl", "xl", "lg"].includes(screen) ? (
                      <Col md="12" className="d-flex w-100">
                        {courseDetailComp()}
                      </Col>
                    ) : (
                      <Col md="12" className="d-flex w-100 flex-column gap-2">
                        <div className="d-flex justify-content-between w-100">
                          <LeftArrow
                            className={"cursorHoverCSS mr-0 ml-0"}
                            onClick={() => {
                              navigate("/admin/mylibrary", {
                                replace: true,
                                state: {
                                  selectedStudent: null,
                                },
                              });
                            }}
                          />
                          {!["xxl", "xl", "lg"].includes(screen) && (
                            <div
                              className="filterSpan d-flex align-items-center"
                              onClick={toggle}
                            >
                              <span className="pr-2">Details</span>
                              {isOpen ? (
                                <UpBlueArrowIcon />
                              ) : (
                                <DownBlueArrowIcon />
                              )}
                            </div>
                          )}
                        </div>
                        <Collapse isOpen={isOpen} className="">
                          {courseDetailComp()}
                        </Collapse>
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </div>
          </StyledCard>
        </Col>
        <Col>
          {["xxl", "xl", "lg"].includes(screen) ? (
            <Row>
              <Col md="4" className="pr-0">
                <StyledCardChapterListing screen={screen}>
                  <ChapterListViewComponent
                    selectedChapter={selectedChapter}
                    setSelectedChapter={setSelectedChapter}
                    chapterList={chapterList}
                    isChapterListLoader={isChapterListLoader}
                    togglePane={togglePane}
                  />
                </StyledCardChapterListing>
              </Col>

              <Col md="8">
                <StyledCardChapterView screen={screen}>
                  <ChapterContentView
                    selectedChapter={selectedChapter}
                    courseId={courseId}
                  ></ChapterContentView>
                </StyledCardChapterView>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md="4">
                <ChapterListViewComponentMB
                  selectedChapter={selectedChapter}
                  chapterList={chapterList}
                  togglePane={togglePane}
                  loading={isChapterListLoader}
                  setSelectedChapter={setSelectedChapter}
                />
              </Col>
              <Col md="8" className="mt-2">
                <StyledCardChapterView screen={screen}>
                  <ChapterContentView
                    selectedChapter={selectedChapter}
                    courseId={courseId}
                  ></ChapterContentView>
                </StyledCardChapterView>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default FacultyContentMain;
